import React, { useState, useRef, useEffect} from 'react'
import SlideSlicker from '../Components/SlickSlider';
import ReservationCompo from '../Components/ReservationCompo';
import ReservationChambreCompo from '../Components/ReservationChambreCompo';
import ReservationSuiteCompo from '../Components/ReservationSuiteCompo';
import CarouselReservation from '../Components/CarouselReservation';

function Hebergement({setActiveTab}) {

const refLink1 = useRef(null)
const refLink2 = useRef(null)
const refLink3 = useRef(null)
const [modal, setModal] = useState(false);
const [modalSuite, setModalSuite] = useState(false);
const [modalChambre, setModalChambre] = useState(false);
const [modalBois, setModalBois] = useState(false);
const [autrePhotos, setAutrePhotos] = useState(false)


// useEffect(() => {


// const interval = setInterval(() => {
    

//  setTimeout(() => {
//     refLink1.current.style.color = 'black'
//     refLink3.current.style.color = ''
//   }, 0);

// setTimeout(() => {
//     refLink2.current.style.color = 'black'
//     refLink1.current.style.color = ''
//   }, 2500);

// setTimeout(() => {
//     refLink3.current.style.color = 'black'
//     refLink2.current.style.color = ''
//   }, 5000);
// setTimeout(() => {
//     refLink3.current.style.color = ''

//   }, 7500);

  
// }, 17500); 
// return () => clearInterval(interval);
// }, [])


  // const [hebergement, setHebergement] = useState('')

  // const renderSwitch = () => { 
  //   switch(hebergement) {
  //     case 'villa':
  //       return <ReservationCompo setActiveTab={setActiveTab} />
  //     case 'chambre':
  //       return <ReservationChambreCompo setActiveTab={setActiveTab}/>
  //     case 'suite':
  //       return <ReservationSuiteCompo  setActiveTab={setActiveTab}/>
  //     default:
  //       return <br />;
  //   }
  // }
const goToGalery = () => {
setTimeout(() => {
  return refLink1.current.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  })
}, 200);
}


  return (
    <div className="hebergement">
      <div className="paddingTopMobile"></div>
      <h1>Suites et chambres</h1>
      <p style={{ textAlign : "center", paddingTop : '1rem', color : "white"}}>
        Betikure dispose de 6 mini villas et d'une suite étudiée pour
        faciliter l'accès aux personnes à mobilité réduite.
      </p>
      <div className="hebergementContent">
        <div className="villaGrid grid">
          <h2>Nos Villas</h2>
            <div className="imageLeftHebergement imagesHebergement"></div>


      
          <div className="imageRightHebergement"></div>
          <p>Chaque chambre est associée à une suite pour former l’une de nos 6 villas. Vous pouvez les réserver séparément ou ensemble : elles communiquent alors par une terrasse et forment une villa confortable pour 6 personnes, jusqu’à 9 avec 3 lits d’appoint.</p>
          <button  onClick={() => setModal(!modal)}>Liste des équipements</button>
          {modal ? (
          <div className="overlay">
            <div className="modal">
            <button  className="buttonModal" onClick={() => setModal(false)}>
          X
        </button>
              <h4>Liste des équipements</h4>
              <br />
              <div className="iframeModal">
            <iframe
            className="ListEquipement"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "100%",
              height: "1320px",
              overflow: "hidden",
            }}
            src="./assets/villa.html"
          ></iframe>
            <iframe
            className="ListEquipementMobile"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "100%",
              height: "700px",
              overflow: "hidden",
            }}
            src="./assets/villaMobile.html"
          ></iframe>

            </div>
            </div>
          </div>
        ) : null}
        </div>
    
        <div className="chambreGrid grid">
          <h2>Nos Chambres</h2>
          <div className="imageChambreHebergement imagesHebergement"></div>
          <p>
            Betikure Parc Lodge compte 6 chambres de 35 m² avec terrasse, prévues pour 2 personnes. Chacune peut accueillir un lit d’appoint et un lit bébé. Salle d’eau avec douche à l’italienne, WC séparés.
          </p>
          <button onClick={() => setModalChambre(!modalChambre)}>Liste des équipements</button>
          {modalChambre ? (
          <div className="overlay">
            <div className="modal">
            <button className="buttonModal" onClick={() => setModalChambre(false)}>
          X
        </button>
              <h4>Liste des équipements</h4>
              <br />
              <div className="iframeModal">
                
            <iframe
            className="ListEquipement"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "80%",
              height: "1320px",
              overflow: "hidden",
            }}
            src="./assets/chambre.html"
          ></iframe>
            <iframe
            className="ListEquipementMobile"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "100%",
              height: "700px",
              overflow: "hidden",
            }}
            src="./assets/chambreMobile.html"
          ></iframe>

            </div>
            </div>
          </div>
        ) : null}
        </div>

        <div className="suiteGrid grid">
          <h2>Nos Suites</h2>
          <div className="imageSuiteHebergement imagesHebergement"></div>
          <p>
            Nos 6 suites de 65 m² disposent de 2 chambres (lits doubles ou simples, au choix), d’une salle d’eau, de WC séparés, d’un salon et d’une cuisine. Elles ont une terrasse haute couverte et une terrasse basse avec jacuzzi privatif. Chaque suite accueille 4 personnes, jusqu’à 6 avec 2 lits d’appoint.</p>

          <button onClick={() => setModalSuite(!modalSuite)}>Liste des équipements</button>
          {modalSuite ? (
          <div className="overlay">
            <div className="modal">
            <button className="buttonModal" onClick={() => setModalSuite(false)}>
          X
        </button>
              <h4>Liste des équipements</h4>
              <br />
                 <div className="iframeModal">
            <iframe
            className="ListEquipement"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "80%",
              height: "1320px",
              overflow: "hidden",
            }}
            src="./assets/suite.html"
          ></iframe>
                    <iframe
            className="ListEquipementMobile"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "100%",
              height: "700px",
              overflow: "hidden",
            }}
            src="./assets/suiteMobile.html"
          ></iframe>
          

            </div>
            </div>
          </div>
        ) : null}
                  <div className="imageSuite2Hebergement imagesHebergement"></div>
        </div>

        <div className="boisGrid grid">
          <h2>Notre Suite Bois Noir</h2>
          <div className="imageBoisNoirGrid imagesHebergement"></div>
          <p>
            Bois Noir est une suite de 50 m² pour 2 personnes, jusqu’à 4 avec 2 lits d’appoint. Elle offre une partie jour avec salon et cuisine, et une partie nuit avec une grande chambre ouverte sur le parc et une terrasse avec jacuzzi privatif.
          </p>
          <div className="imageBoisNoir2Grid imagesHebergement"></div>
          <p>
            Sans être médicalisée, elle est adaptée aux personnes à mobilité réduite : de plain-pied, proche de la piste d’accès, avec de larges dégagements et une cuisine adaptée.
          </p>
          <button onClick={() => setModalBois(!modalBois)}>Liste des équipements</button>
          {modalBois ? (
          <div className="overlay">
            <div className="modal">
            <button className="buttonModal" onClick={() => setModalBois(false)}>
          X
        </button>
              <h4>Liste des équipements</h4>
              <br />
              <div className="iframeModal">
            <iframe
            className="ListEquipement"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "80%",
              height: "1320px",
              overflow: "hidden",
            }}
            src="./assets/bois_noir.html"
            ></iframe>
                      <iframe
            className="ListEquipementMobile"
            title="ListEquipement"
            style={{
              borderStyle: "none",
              width: "100%",
              height: "700px",
              overflow: "hidden",
            }}
            src="./assets/bois_noirMobile.html"
          ></iframe>
            </div>

            </div>
          </div>
        ) : null}
        </div>
     
        <p className="hebergementPCenter">
          Notre parc est vallonné. Si vous avez des difficultés à vous déplacer, signalez-le-nous à la réservation : nous vous proposerons l’hébergement le plus adapté et pourrons vous aider pour vos bagages et vos déplacements sur place.
        </p>
        <div className='buttonContainerHebergement'>
        <button className='active' onClick={() =>  {setAutrePhotos(true);goToGalery()} }>Galerie d'images</button>
        </div>

      </div>

  <div ref={refLink1} id="bottomHebergementContainer">
  {
      autrePhotos &&

      <CarouselReservation hebergement={"all"} />
  }



</div>
<br />
    </div>
  );
}

export default Hebergement